// import eeuu from '../../images/eeuu.png';
// import arg from '../../images/argentina.png';
// import iconoStock from '../../images/stockDisponible.png';
// import wapp from '../../images/wapp.png';


// export default function ModalArticulo({ selectedArticulo, closeModal }) {


//     const enviarWapp = (precio) => {
//         if (!precio) {
//             alert("Precio no disponible.");
//             return;
//         }

//         const precioConIVA = precio * ((selectedArticulo?.Alicuota / 100) + 1);
//         const precioFormateado = precioConIVA.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//         const message = `*CHABOUX - CLUSTER*\nArtículo: ${selectedArticulo?.Descripcion?.trim()}.\nPrecio: ${selectedArticulo?.Monedadolar == '0' ? '$' : 'U$S'} ${precioFormateado}\n--- Precio de venta con IVA incluido ---`;
//         const encodedMessage = encodeURIComponent(message);
//         const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;

//         window.open(whatsappUrl, "_blank");
//     };


//     return (


//         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
//             <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-lg relative">

//                 {/* Header */}
//                 <div className="text-center mb-3">
//                     <p className="text-sm text-gray-500">
//                         Precio actualizado al: {selectedArticulo?.Fupcosto ? selectedArticulo.Fupcosto.split('-').reverse().join('/') : ''}
//                     </p>
//                     <div className="flex justify-center items-center gap-2 mt-1">
//                         <img src={selectedArticulo?.Monedadolar?.trim() === '1' ? eeuu : arg} alt="Moneda" className="w-5 h-5" />
//                         <span className="text-sm font-semibold">{selectedArticulo?.Codigo}</span>
//                         {parseFloat(selectedArticulo?.Stocktotal) > 0 && (
//                             <img src={iconoStock} alt="stock" className="w-6 h-6" />
//                         )}
//                     </div>
//                     <h3 className="font-bold text-md mt-2">{selectedArticulo?.Codorigen}</h3>
//                     <h2 className="text-blue-700 font-semibold text-lg">{selectedArticulo?.Descripcion}</h2>
//                 </div>

//                 {/* Stock */}
//                 {parseFloat(selectedArticulo?.Stocktotal) > 0 && (
//                     <p className="text-center text-gray-700 font-medium border-t border-gray-300 pt-2 mb-4">
//                         STOCK TOTAL: {selectedArticulo?.Stocktotal}
//                     </p>
//                 )}

//                 {/* PRECIO PÚBLICO */}
//                 <div className="mb-6">
//                     <p className="text-center text-red-600 font-semibold text-base mb-2">Precio Público</p>
//                     <div className="grid grid-cols-3 gap-3">
//                         {['Prevtapub1', 'Prevtapub2', 'Prevtapub3'].map((key, i) => (
//                             <div key={i} className="rounded-xl overflow-hidden shadow-md border border-gray-200">
//                                 {/* Parte superior: Nombre + Precio */}
//                                 <div className="bg-white p-2 text-center">
//                                     <p className="font-bold text-xs text-gray-700">PvtaP{i + 1}</p>
//                                     <p className="text-sm font-semibold text-gray-800">
//                                         {(parseFloat(selectedArticulo?.[key]) * ((selectedArticulo?.Alicuota / 100) + 1)).toLocaleString("es-AR", {
//                                             minimumFractionDigits: 2,
//                                             maximumFractionDigits: 2
//                                         })}
//                                     </p>
//                                 </div>

//                                 {/* Parte inferior: Botón WhatsApp */}
//                                 <button
//                                     onClick={() => enviarWapp(selectedArticulo?.[key])}
//                                     className="w-full bg-green-100 hover:bg-green-200 active:bg-green-300 transition-all py-2 flex items-center justify-center"
//                                 >
//                                     <img src={wapp} alt="WhatsApp" className="w-7 h-7" />
//                                 </button>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* PRECIO MAYORISTA */}
//                 <div className="mb-10">
//                     <p className="text-center text-red-600 font-semibold text-base mb-2">Precio Mayorista</p>
//                     <div className="grid grid-cols-3 gap-3">
//                         {['Prevtamay1', 'Prevtamay2', 'Prevtamay3'].map((key, i) => (
//                             <div key={i} className="rounded-xl overflow-hidden shadow-md border border-gray-200">
//                                 <div className="bg-white p-2 text-center">
//                                     <p className="font-bold text-xs text-gray-700">PvtaM{i + 1}</p>
//                                     <p className="text-sm font-semibold text-gray-800">
//                                         {(parseFloat(selectedArticulo?.[key]) * ((selectedArticulo?.Alicuota / 100) + 1)).toLocaleString("es-AR", {
//                                             minimumFractionDigits: 2,
//                                             maximumFractionDigits: 2
//                                         })}
//                                     </p>
//                                 </div>
//                                 <button
//                                     onClick={() => enviarWapp(selectedArticulo?.[key])}
//                                     className="w-full bg-green-100 hover:bg-green-200 active:bg-green-300 transition-all py-2 flex items-center justify-center"
//                                 >
//                                     <img src={wapp} alt="WhatsApp" className="w-7 h-7" />
//                                 </button>
//                             </div>
//                         ))}
//                     </div>
//                 </div>

//                 <div className="absolute bottom-0 left-0 w-full ">
//                     <button
//                         className="px-4 py-2 bg-red-500 text-white font-semibold w-full text-xl rounded-b-lg hover:bg-red-600 transition-colors"
//                         onClick={closeModal}
//                     >
//                         CERRAR
//                     </button>
//                 </div>

//             </div>
//         </div>



//     );
  
// }


import eeuu from '../../images/eeuu.png';
import arg from '../../images/argentina.png';
import iconoStock from '../../images/stockDisponible.png';
import wapp from '../../images/wapp.png';
import { useState } from 'react';

export default function ModalArticulo({ selectedArticulo, closeModal, vista = 'selector' }) {

    const enviarWapp = (precio) => {
        if (!precio) {
            alert("Precio no disponible.");
            return;
        }

        const precioConIVA = precio * ((selectedArticulo?.Alicuota / 100) + 1);
        const precioFormateado = precioConIVA.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        const message = `*CHABOUX - CLUSTER*\nArtículo: ${selectedArticulo?.Descripcion?.trim()}.\nPrecio: ${selectedArticulo?.Monedadolar == '0' ? '$' : 'U$S'} ${precioFormateado}\n--- Precio de venta con IVA incluido ---`;
        const encodedMessage = encodeURIComponent(message);
        const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;

        window.open(whatsappUrl, "_blank");
    };

    const formatValue = (value) => {
        return (parseFloat(value) * ((selectedArticulo?.Alicuota / 100) + 1)).toLocaleString("es-AR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const tipos = {
        publico: { label: 'Público', corto: 'P', prefijo: 'Prevtapub', color: 'bg-brand-500' },
        mayorista: { label: 'Mayorista', corto: 'M', prefijo: 'Prevtamay', color: 'bg-amber-500' },
    };

    const [tipo, setTipo] = useState('publico');
    const [lista, setLista] = useState(1);

    const keySeleccionada = `${tipos[tipo].prefijo}${lista}`;
    const precioSeleccionado = selectedArticulo?.[keySeleccionada];
    const fechaActualizacion = selectedArticulo?.Fupcosto ? selectedArticulo.Fupcosto.split('-').reverse().join('/') : '--/--/----';
    const esLista = vista === 'lista';

    // Cierra al tocar el fondo oscuro (no el contenido del modal)
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) closeModal();
    };

    const segmento = (activo) =>
        `flex h-10 flex-1 items-center justify-center rounded-lg text-sm font-semibold transition lg:h-9 ${activo
            ? 'bg-white text-slate-900 shadow-sm ring-1 ring-slate-200 dark:bg-slate-700 dark:text-white dark:ring-slate-600'
            : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200'}`;

    const botonCerrar = (
        <button
            onClick={closeModal}
            className="h-11 rounded-xl border border-slate-200 bg-white px-5 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 active:scale-[0.98] dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700 lg:h-9 lg:rounded-lg lg:px-4"
        >
            Cerrar
        </button>
    );

    return (
        <div
            onClick={handleOverlayClick}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 p-4 backdrop-blur-sm animate-fade-in dark:bg-black/70 sm:p-6"
        >
            <div
                role="dialog"
                aria-modal="true"
                className="relative flex max-h-[90dvh] w-full max-w-md flex-col overflow-hidden rounded-2xl bg-white shadow-2xl animate-sheet-up dark:bg-slate-900 dark:ring-1 dark:ring-slate-800 lg:max-w-3xl"
            >
                {/* Encabezado */}
                <div className="relative px-5 pb-3 pt-4 lg:px-6">
                    <button
                        onClick={closeModal}
                        aria-label="Cerrar"
                        className="absolute right-2.5 top-2.5 flex h-10 w-10 items-center justify-center rounded-full text-slate-400 transition hover:bg-slate-100 hover:text-slate-600 dark:text-slate-500 dark:hover:bg-slate-800 dark:hover:text-slate-200 lg:right-3 lg:top-3 lg:h-8 lg:w-8"
                    >
                        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>

                    <div className="mb-1.5 flex flex-wrap items-center gap-2 pr-10">
                        <img
                            src={selectedArticulo?.Monedadolar?.trim() === '1' ? eeuu : arg}
                            alt="Moneda"
                            className="h-4 w-6 rounded-[3px] object-cover ring-1 ring-black/5"
                        />
                        <span className="rounded-md bg-slate-100 px-2 py-0.5 font-mono text-xs font-semibold text-slate-700 dark:bg-slate-800 dark:text-slate-300">
                            {selectedArticulo?.Codigo}
                        </span>
                        {selectedArticulo?.Codorigen?.trim() && (
                            <span className="font-mono text-xs uppercase tracking-wide text-slate-400 dark:text-slate-500">{selectedArticulo?.Codorigen}</span>
                        )}
                        {parseFloat(selectedArticulo?.Stocktotal) > 0 && (
                            <span className="flex items-center gap-1 rounded-full bg-emerald-50 py-0.5 pl-1 pr-2 text-[11px] font-semibold text-emerald-700 ring-1 ring-inset ring-emerald-600/15 dark:bg-emerald-500/10 dark:text-emerald-400 dark:ring-emerald-400/20">
                                <img src={iconoStock} alt="stock" className="h-4 w-4" />
                                Stock: <span className="tabular-nums">{selectedArticulo?.Stocktotal}</span>
                            </span>
                        )}
                    </div>

                    <h2 className="text-base font-semibold leading-snug text-slate-900 dark:text-white lg:pr-10 lg:text-lg">
                        {selectedArticulo?.Descripcion}
                    </h2>
                    <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
                        IVA incluido · Actualizado al {fechaActualizacion}
                    </p>
                </div>

                {esLista ? (
                    /* Vista lista: todos los precios con su botón de WhatsApp (en PC, en dos columnas) */
                    <div className="grid flex-1 gap-3 overflow-y-auto overscroll-contain border-t border-slate-100 px-5 py-3 dark:border-slate-800 lg:grid-cols-2 lg:gap-5 lg:px-6 lg:py-4">
                        {Object.values(tipos).map((t) => (
                            <section key={t.prefijo}>
                                <h3 className="mb-1.5 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                                    <span className={`h-1.5 w-1.5 rounded-full ${t.color}`} />
                                    Precio {t.label.toLowerCase()}
                                </h3>
                                <div className="divide-y divide-slate-100 overflow-hidden rounded-xl border border-slate-200 dark:divide-slate-800 dark:border-slate-800">
                                    {[1, 2, 3].map((n) => (
                                        <div key={n} className="flex items-center gap-2.5 bg-white px-2.5 py-1.5 dark:bg-slate-900">
                                            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-slate-100 text-[11px] font-semibold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
                                                {t.corto}{n}
                                            </span>
                                            <p className="min-w-0 flex-1 truncate text-[15px] font-semibold tabular-nums text-slate-900 dark:text-white lg:text-sm">
                                                $ {formatValue(selectedArticulo?.[`${t.prefijo}${n}`])}
                                            </p>
                                            <button
                                                onClick={() => enviarWapp(selectedArticulo?.[`${t.prefijo}${n}`])}
                                                aria-label={`Enviar ${t.label} ${n} por WhatsApp`}
                                                title="Enviar por WhatsApp"
                                                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#25D366] shadow-sm transition hover:bg-[#1fbd5a] active:scale-95 lg:h-8 lg:w-8"
                                            >
                                                <img src={wapp} alt="" className="h-[18px] w-[18px] invert" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        ))}
                    </div>
                ) : (
                    /* Vista selector: botones que cambian el precio mostrado (en PC, a lo horizontal) */
                    <div className="grid flex-1 gap-3 overflow-y-auto overscroll-contain border-t border-slate-100 px-5 py-4 dark:border-slate-800 lg:grid-cols-2 lg:items-center lg:gap-6 lg:px-6">
                        <div className="space-y-2.5">
                            <div className="flex gap-1 rounded-xl bg-slate-100 p-1 dark:bg-slate-800" role="tablist" aria-label="Tipo de precio">
                                {Object.entries(tipos).map(([id, t]) => (
                                    <button
                                        key={id}
                                        role="tab"
                                        aria-selected={tipo === id}
                                        onClick={() => setTipo(id)}
                                        className={segmento(tipo === id)}
                                    >
                                        {t.label}
                                    </button>
                                ))}
                            </div>

                            <div className="flex gap-1 rounded-xl bg-slate-100 p-1 dark:bg-slate-800" role="tablist" aria-label="Lista de precio">
                                {[1, 2, 3].map((n) => (
                                    <button
                                        key={n}
                                        role="tab"
                                        aria-selected={lista === n}
                                        onClick={() => setLista(n)}
                                        className={segmento(lista === n)}
                                    >
                                        {tipos[tipo].label} {n}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Precio destacado */}
                        <div className="rounded-2xl border border-brand-100 bg-gradient-to-b from-brand-50 to-white px-4 py-5 text-center dark:border-brand-900 dark:from-brand-950 dark:to-slate-900">
                            <p className="text-[11px] font-semibold uppercase tracking-wider text-brand-700 dark:text-brand-300">
                                {tipos[tipo].label} {lista}
                            </p>
                            <p key={keySeleccionada} className="mt-1 text-3xl font-bold tracking-tight tabular-nums text-slate-900 animate-fade-in dark:text-white sm:text-4xl">
                                <span className="mr-1 text-xl font-semibold text-slate-400 dark:text-slate-500 sm:text-2xl">$</span>
                                {formatValue(precioSeleccionado)}
                            </p>
                        </div>
                    </div>
                )}

                {/* Acciones */}
                <div className="flex gap-2 border-t border-slate-100 bg-white px-5 py-3 dark:border-slate-800 dark:bg-slate-900 lg:justify-end lg:px-6">
                    {esLista ? (
                        <div className="flex-1 lg:flex-none [&>button]:w-full">{botonCerrar}</div>
                    ) : (
                        <>
                            {botonCerrar}
                            <button
                                onClick={() => enviarWapp(precioSeleccionado)}
                                className="flex h-11 flex-1 items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 text-sm font-semibold text-white shadow-sm shadow-emerald-900/10 transition hover:bg-[#1fbd5a] active:scale-[0.98] lg:h-9 lg:flex-none lg:rounded-lg"
                            >
                                <img src={wapp} alt="" className="h-5 w-5 invert lg:h-4 lg:w-4" />
                                Enviar por WhatsApp
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
